import React, { createContext, useContext, useState, useCallback } from "react";
import { translations } from "./translations";

const LanguageContext = createContext({
  lang: "es",
  setLang: () => {},
  t: () => "",
});

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("es");

  const t = useCallback(
    (path) => {
      const parts = path.split(".");
      let cur = translations[lang];
      for (const p of parts) {
        if (cur == null) return path;
        cur = cur[p];
      }
      return cur ?? path;
    },
    [lang],
  );

  const toggle = () => setLang((l) => (l === "es" ? "en" : "es"));

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
